import { defineComponent as _defineComponent } from 'vue'
import SidebarHeadline from '@/shared/components/SidebarHeadline.vue';
import Button from '@/shared/components/buttons/Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepAnalyse',
  emits: ["show:history"],
  setup(__props, { emit }: { emit: ({
  (e: 'show:history'): void;
}), expose: any, slots: any, attrs: any }) {



return { __sfc: true,emit, SidebarHeadline, Button }
}

})